import type { GlobalAddress } from "@interfaces/address/globalAddress";
import type { CountryCode } from "@config/site/types";

type ExtraConfigProps = {
    country: CountryCode;
};

export const useExtraConfig = ({ country }: ExtraConfigProps) => {
    const addressConfig = (address: GlobalAddress) => ({
        KR: {
            address: address.extra?.fullAddress,
        },
    });

    const modifyFullAddress = (address: GlobalAddress) => addressConfig(address)[country]?.address;

    return {
        modifyFullAddress,
    };
};
